import React from 'react'
import CreateTourPackageWorker from './create'
import { Link, withRouter } from 'react-router-dom'
import TourPackageForm from '../components/form/form.component'
import TourPackageImages from '../components/images/images.component'
import FormHelper from '../../../../utils/FormHelper'
import Dialog from '../../../../components/dialog/dialog.component'
import Loading from '../../../../components/loading/loading.component'
import './create.styles.scss'

class CreateTourPackage extends React.Component {

    constructor(props) {
        super(props)
        this.createTourPackageWorker = CreateTourPackageWorker(this)
        this.state = this.createTourPackageWorker.getDefaultState()
    }

    onSubmit = (e) => {
        e.preventDefault()
        this.createTourPackageWorker.isValid() && this.createTourPackageWorker.createTourPackage()
    }

    onCancel = () => this.props.history.push('/content/tour-packages')

    render() {
        return (
            <div className="create-tour-package">
                {
                    (this.state.creatingTourPackage || this.state.updatingTourPackage) && <Dialog><Loading /></Dialog>
                }
                <div className="card">
                    <Link className="btn" to="/content/tour-packages">Tour Packages</Link>
                    <div className="header">
                        <h4>Create Tour Package</h4>
                    </div>
                    <div className={"flag " + this.state.flag.type}>
                        {this.state.flag.text}
                    </div>
                    <TourPackageForm {...this.state} action="Add Tour Package" onChange={FormHelper(this).onChange} onSubmit={this.onSubmit} onCancel={this.onCancel}>
                        <TourPackageImages tourPackageId={this.state.id} images={this.state.images} />
                    </TourPackageForm>
                </div>
            </div>
        )
    }
}

export default withRouter(CreateTourPackage)
